import React from "react";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";

function DeleteConfig(props) {

  return (
    <BasicModal
      popupOpen={props?.deleteUtilityPopUp}
      bodyMessage={<>
        <img src={deleteImg} alt="approve" className="w-40px" />
        <div className="delete-hotel mb-3">{props?.isUtilityDeletedRef.current?.isUtilityDeletedModalData ?
          <div className="confirm-delete-hotel">
            <p>Do you really want to Delete Satellite Channel No<br/> <b>{props?.isUtilityDeletedRef.current?.isUtilityDeletedModalData.row.lcn}</b> ?</p>
            <p className="warning"><IoMdWarning /> Warning</p>
            <p>Satellite Channel No "{props?.isUtilityDeletedRef.current?.isUtilityDeletedModalData.row.lcn}" will be permanently deleted <br />
              Deleting the specified Satellite Channel No can't be undone.
            </p>
            <p className="mt-3">To confirm deletion, type "Delete {props?.isUtilityDeletedRef.current?.isUtilityDeletedModalData.row.lcn}"</p>
            <div className="form-group-hotel mt-3">
              <div className="floating-label">
                <input
                  id="deleteHotel"
                  placeholder=''
                  onChange={(e) => props?.setConfirmDeleteUtilityRow(e.target.value)}
                />
                <label htmlFor="deleteHotel">Delete {props?.isUtilityDeletedRef.current?.isUtilityDeletedModalData.row.lcn}</label>
              </div>
              {(props?.confirmDeleteUtilityRow === "" && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete {props?.isUtilityDeletedRef.current?.isUtilityDeletedModalData.row.lcn}</small></p>
              ) : (props?.confirmDeleteUtilityRow !== `Delete ${props?.isUtilityDeletedRef.current?.isUtilityDeletedModalData.row.lcn}` && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete {props?.isUtilityDeletedRef.current?.isUtilityDeletedModalData.row.lcn}</small></p>
              ) : ""
              }
            </div>
          </div> :
          props?.isUtilityDeletedRef.current?.userConformationModalData?.successMessage}</div>
      </>
      }
      footer={
        props?.isUtilityDeletedRef.current?.isUtilityDeletedModalData ?
          {
            primaryButton: {
              buttonName: "Cancel",
              action: props?.popupCloseHandler
            }
            ,
            secondaryButton: {
              buttonName: "Delete",
              action: props?.deleteUtilityHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: props?.popupCloseHandler
            }
          }
      }
    />
  );
}

export default DeleteConfig;
